import script from "./PhoneMyMusic.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMyMusic.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMyMusic.vue?vue&type=style&index=0&id=3db8c97e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db8c97e"]])

export default __exports__